module.exports = __webpack_public_path__ + "static/media/both-tf.d080891b.svg";